import React from 'react';
import SRC from '@Theme/images/new-layout.png';
import './text.css';

function _TextTemp() {
  return (
    <div className="onsite-text-layout">
      <div className="onsite-img-container">
        <img src={SRC} width="100%" />
      </div>
      <span className="onsite-message-title">Message Title</span>
      <span className="onsite-message-body">Message body</span>
      <button>Button</button>
    </div>
  );
}

export { _TextTemp };
